import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tenantSettingsService } from 'shared/services';
import { purchaseRequestService } from '../../api/purchase-request.service';
import { EnhancedDialog } from 'components/enhanced';
import { SectionHeader } from 'components/ui/typography';

interface SendPurchaseOrderEmailDialogProps {
  open;
  onClose;
  order_id?: number;
  onSubmit: (text) => void;
  lines?: any[];
}
function SendPurchaseOrderEmailDialog({
  order_id,
  open,
  onClose,
  onSubmit,
  lines
}: SendPurchaseOrderEmailDialogProps) {
  const translationPrefix = 'pages.orders.show-email';
  const { t } = useTranslation();

  const [emailBody, setEmailBody] = useState<string>();
  const [emailCC, setEmailCC] = useState<string>();
  const [emailRecipient, setEmailRecipient] = useState<string>();

  useEffect(() => {
    if (!open) return;

    tenantSettingsService.get(1).then((res) => {
      setEmailBody(res.orders_default_email_body);
      const emailCC = [res.cc_orders]
        .filter(Boolean)
        .map((item) => item.replace(/;/g, ' '))
        .join(' ');
      setEmailCC(emailCC);
    });
    if (order_id) {
      purchaseRequestService.getEmailList(order_id).then((res) => {
        const contracts = (res.contracts || []).filter(Boolean);
        const suppliers = (res.suppliers || []).filter(Boolean);
        const emails = contracts.length ? contracts : suppliers;
        setEmailRecipient(emails.join(' '));
      });
    }
  }, [open, order_id]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <EnhancedDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={t(`${translationPrefix}.title`)}
      subTitle={t(`${translationPrefix}.subtitle`)}
      submitLabel={t(`actions.confirm`)}
      submitButtonProps={{ type: 'submit', form: 'sendEmailOrder' }}>
      <EnhancedForm
        onSubmit={handleSubmit}
        formId="sendEmailOrder"
        hideControls
        autoStyleLayout={true}
        columns={1}>
        <SectionHeader
          title={t(`${translationPrefix}.current_email_addresses`, { emails: emailRecipient })}
          gridSpan
        />
        {/* <IdentityField
          name="email_recipient"
          component={TextFieldAdapter}
          label={t('global.more-recipient')}
          placeholder={t(`${translationPrefix}.recipients-placeholder`)}
          // initialValue={emailRecipient ? emailRecipient : ''}
          type="text"
        /> */}
        <br />
        <IdentityField
          name="email_cc"
          component={TextFieldAdapter}
          label={t('global.cc')}
          initialValue={emailCC ? emailCC : ''}
          type="text"
        />
        <IdentityField
          name="email_body"
          component={TextFieldAdapter}
          label={t('global.message')}
          placeholder={t('global.message-placeholder')}
          initialValue={emailBody ? emailBody : ''}
          type="text"
          multiline
          rows={4}
        />
      </EnhancedForm>
    </EnhancedDialog>
  );
}

export default SendPurchaseOrderEmailDialog;
